export const environment = {
  production: true,
  apiUrl: 'https://ofztsbf72elpaxb2esdklcgpkq0tlrbw.lambda-url.us-east-1.on.aws/',
  geoApi: '',
  mapEndpoint: 'https://maps.googleapis.com/maps/api/js',
  // mapKey: 'AIzaSyBxbjK-hWHC35NMJGTvvXV5L8BWMVivItg',
  mapKey: 'AIzaSyDzxpkF9O5vDBoMXJGpv6p508siVF3wYCk',
  urlImages: 'https://efaysto-staging-20240708162138110700000001.s3.us-east-1.amazonaws.com/',
  efaystoWallet: '0x9745DcAb234f4DcF8A299B22e2E18cE31fe6A04F',
  efaystoContactName: 'SIMON_TEST_TOKEN',
  RWA_CONTRACT: '0xFB06F2E2dD7295A354E5910B9FbC6f70C5354D76',
  gaMeasurementId: '',
  metaPixelId: ''
};
